const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

const PLACEHOLDER_WORKFLOW_IDS = new Set([
  '00000000-0000-0000-0000-000000000000',
  'ffffffff-ffff-ffff-ffff-ffffffffffff',
]);

export function normalizeConcreteWorkflowId(value: unknown): string | null {
  if (typeof value !== 'string') return null;

  const workflowId = value.trim().toLowerCase();
  if (!UUID_PATTERN.test(workflowId)) return null;
  if (PLACEHOLDER_WORKFLOW_IDS.has(workflowId)) return null;

  return workflowId;
}
